const FormResources = {

    form_data:{
        day_rotations: '',
        start_date: '',
        description: '',
        shift: 1,
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            disabled:   false,
            step:       '',
            name:       'Number days per rotation:',
            model_name: 'day_rotations',
            ref:        'day_rotations_input',
            ref_alt:    'day_rotations_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            minlength:  '',
            disabled:   false,
            step:       '',
            name:       'Schedule start date:',
            model_name: 'start_date',
            ref:        'start_date_input',
            ref_alt:    'start_date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift',
            ref:        'shift_input',
            ref_alt:    'shift_input_alt',
            required:   true,
        },
    ],

    shift_option:[
        {
            id:     1,
            name:   'Day',
        },
        {
            id:     2,
            name:   'Evening',
        },
        {
            id:     3,
            name:   'Night',
        },
        {
            id:     4,
            name:   'All shift',
        },
    ],

    schedule_options:[
        {
            id:     1,
            name:   'Monday',
        },
        {
            id:     2,
            name:   'Tuesday',
        },
        {
            id:     3,
            name:   'Wednesday',
        },
        {
            id:     4,
            name:   'Thursday',
        },
        {
            id:     5,
            name:   'Friday',
        },
        {
            id:     6,
            name:   'Saturday',
        },
        {
            id:     7,
            name:   'Sunday',
        },
    ],

    day_rotations:[
        {
            id:     '',
            name:   'Select an option',
        },
        {
            id:     7,
            name:   '7',
        },
        {
            id:     14,
            name:   '14',
        },
        {
            id:     21,
            name:   '21',
        },
        {
            id:     28,
            name:   '28',
        },
        {
            id:     35,
            name:   '35',
        },
        {
            id:     42,
            name:   '42',
        },
    ],

}

export default FormResources;